import swal from 'sweetalert'

const showRequestError = (error) => {
  const response = error?.response
  if (!response) {
    swal('Connection problem', error?.message || 'The payment gateway API is unavailable.', 'warning')
    return
  }

  const message = response?.data?.message || response.statusText || 'Request failed'
  if (![401, 403].includes(response.status)) {
    swal(`Request failed (${response.status})`, message, 'warning')
  }
}

export const CatchError = (error, navigation) => {
  const status = error?.response?.status

  if (status === 401 || status === 403) {
    sessionStorage.clear()
    navigation('/auth/login', { replace: true })
    return error
  }

  showRequestError(error)
  return error
}

export const CatchErrorDashboard = (error, navigation) => CatchError(error, navigation)

export const CatchLoginError = (error, navigation, isNav = false) => {
  showRequestError(error)
  if (isNav && typeof navigation === 'function') navigation('/auth/login')
  return error
}
